import React from 'react';
import ReactPaginate from 'react-paginate';


const Pagination = ({
    data = [],
    getData
}) => {

    return (
        <>
            <ReactPaginate
                nextLabel="Next >"
                onPageChange={e => getData(e.selected + 1)}
                pageRangeDisplayed={3}
                marginPagesDisplayed={2}
                pageCount={data?.pagination?.totalPages || 10}
                previousLabel="< Prev"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                breakLabel="..."
                breakClassName="page-item"
                breakLinkClassName="page-link"
                containerClassName="pagination float-right"
                activeClassName="active"
                renderOnZeroPageCount={null}
                forcePage={data?.pagination?.currentPage - 1}
            />
            {/* <div className="d-flex p-3">
                <button
                    className="site-button button-sm"
                    disabled={data.pagination?.previousPage ? false : true}
                    onClick={() => getData(data.pagination?.previousPage)}
                    style={{ backgroundColor: data.pagination?.previousPage ? "#1d46f5" : "#8b99d5", cursor: data.pagination?.previousPage ? "pointer" : "not-allowed" }}
                >
                    <i className="ti-arrow-left"></i> Prev
                </button>
                <span className='mr-auto ml-auto'>{data?.pagination?.currentPage}</span>
                <button
                    className="site-button button-sm"
                    disabled={data.pagination?.nextPage ? false : true}
                    onClick={() => getData(data.pagination?.nextPage)}
                    style={{ backgroundColor: data.pagination?.nextPage ? "#1d46f5" : "#8b99d5", cursor: data.pagination?.nextPage ? "pointer" : "not-allowed" }}
                >
                    Next <i className="ti-arrow-right"></i>
                </button>
            </div> */}
        </>
    );
};

export default Pagination;